<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">{{ titulo }}</span>
                <div class="float-right">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="$emit('atualizarListagem')"
                        ></i>
                    </span>
                </div>
            </b-card-header>
            <b-card-body>
                <slot name="controles"></slot>
                <totais-status
                    :totaisStatus="totaisStatus"
                    v-if="totaisStatus"
                ></totais-status>
                <app-tabela
                    idTabela="tblFinalizacoes"
                    :itens="finalizacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <app-finalizacao-inserir
                            :finalizacoesServicos="finalizacoesServicos"
                            @detalharFinalizacao="
                                $emit('detalharFinalizacao', $event)
                            "
                        ></app-finalizacao-inserir>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="protocolo" slot-scope="data">
                        {{ data.protocolo }}
                        <span v-if="data.prioritario"
                            ><br /><app-status status="PRIORITÁRIO"></app-status
                        ></span>
                        <span v-if="data.especial"
                            ><br />
                            <app-status status="ESPECIAL"></app-status>
                        </span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import FinalizacaoInserir from './FinalizacaoInserir'
import TotaisStatus from './TotaisStatus'

export default {
    props: {
        titulo: {
            type: String,
            default: () => 'PAGAMENTOS DO SGF'
        },

        finalizacoes: {
            type: Array,
            default: () => []
        },

        totaisStatus: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        },

        showCredenciado: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'credenciado',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdEntregas',
                    label: 'Entregas',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdDespViagens',
                    label: 'Desp. Viagens',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Anexos',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {},

    created() {
        if (!this.showCredenciado) {
            this.campos.splice(1, 1)
        }
    },

    computed: {},

    watch: {},

    components: {
        AppFinalizacaoInserir: FinalizacaoInserir,
        TotaisStatus
    }
}
</script>
